import { render } from "./office.svg?vue&type=template&id=83bab5b6"
const script = {}
script.render = render

export default script